import { Component, OnInit } from "@angular/core";

import { Context } from "@hermes/app-core";

import { HomePageAnalyticsService } from "../services/home-page-analytics.service";
import { HomePageHeadService } from "../services/home-page-head.service";
import { HomePageTrayService } from "../services/home-page-tray.service";

@Component({
    selector: "h-home-page",
    templateUrl: "./home-page.component.html",
})
export class HomePageComponent implements OnInit {
    constructor(
        private readonly homePageHeadService: HomePageHeadService,
        private readonly homePageAnalyticsService: HomePageAnalyticsService,
        private homePageTrayService: HomePageTrayService,
        private context: Context,
    ) {}

    public ngOnInit(): void {
        this.homePageHeadService.setHeadData();
        this.homePageAnalyticsService.sendPageViewEvent();
        if (this.context.isInBrowserMode()) {
            this.homePageTrayService.checkUrlToOpenAssociatedTray();
        }
    }
}
